import { render, staticRenderFns } from "./aylPie.vue?vue&type=template&id=4133d214&scoped=true"
import script from "./aylPie.vue?vue&type=script&lang=js"
export * from "./aylPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4133d214",
  null
  
)

export default component.exports